import React, { useState } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';

import { connect } from '../../../../../../StateProvider';

import Icon from '../../../../Icon';
import LinkedItem from '../../../../LinkedItem';
import RecordFields from '../../../../../../Record/RecordBody/mainTab/RecordFields';

import styles from '../links.less';

const CardItem = (props) => {
  const [hovered, setHovered] = useState(false);

  const hover = () => {
    setHovered(true);
  };
  const blur = () => {
    setHovered(false);
  };

  const { extFields } = props;
  const extValues = props.values || Immutable.Map();

  const {
    t,
    item,
    params,
    removed,
    sceneId,
    readOnly,
    removable,
    compact,
    onRemoveItem,
    onSaveExtField,
    onUpdateExtField,
  } = props;

  return (
    <div className={cn(styles.cardItem, { [styles.cardItemHovered]: hovered })}>
      <LinkedItem
        sceneId={sceneId}
        className={styles.cardItemActions}
        removed={removed}
        removable={removable}
        titleOnRemove={t('record.fields.object.delete')}
        item={{
          key: item.get('key'),
          text: '',
          icon: <Icon type="icon programing-21" title={t('record.fields.object.open')} />,
        }}
        onClickRemove={onRemoveItem}
        linkProps={{
          onMouseEnter: hover,
          onMouseLeave: blur,
        }}
        params={params}
      />
      <RecordFields
        sceneId={sceneId}
        catalogId={item.getIn(['item', 'catalogId'])}
        recordId={item.getIn(['item', 'recordId'])}
        catalog={props.catalog}
        fields={extFields}
        values={extValues}
        onSaveField={onSaveExtField}
        onUpdateField={onUpdateExtField}
        readOnly={readOnly}
        viewOnly={readOnly}
        compact={compact}
      />
    </div>
  );
};

CardItem.propTypes = {
  extFields: PropTypes.object,
  item: PropTypes.object,
  params: PropTypes.object,
  removed: PropTypes.bool,
  removable: PropTypes.bool,
  readOnly: PropTypes.bool,
  onSaveExtField: PropTypes.func,
  onUpdateExtField: PropTypes.func,
  onRemoveItem: PropTypes.func,
};

export default withTranslation()(
  connect(CardItem, ['catalogs', 'records'], (props, { catalogs, records }) => {
    const catalogId = props.item.getIn(['item', 'catalogId']);
    const recordId = props.item.getIn(['item', 'recordId']);
    const catalogFields = catalogs.getIn([catalogId, 'fields']);
    const catalog = catalogs.get(catalogId);
    const values = records.getIn([catalogId, recordId, 'values']);
    return {
      catalog,
      catalogFields,
      values,
      ...props,
    };
  }),
);
